<template>
    <div id="listCitation">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="canAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Citation List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-invoice-list">
                        <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getUploadedCitationList" v-on:click="getUploadedCitationList(this)" :class="'btn btn-secondary '+ uploadedSelected"> Uploaded </button>
                                    <button type="button" id="getInProgressCitationList" v-on:click="getInProgressCitationList(this)" :class="'btn btn-secondary '+ inProgressSelected"> In Progress </button>
                                    <button type="button" id="getProcessedCitationList" v-on:click="getProcessedCitationList(this)" :class="'btn btn-secondary '+ processedSelected"> Processed </button>
                                    <button type="button" id="getAllCitationList" v-on:click="getAllCitationList(this)" :class="'btn btn-secondary '+ allSelected"> All </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="admin-page-content citation-list">
                        <data-table-filter-config :moduleName="'citationList'" ref="filterComponent" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNum}} is processing please wait! <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                        <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'citationList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listCitationTable"
                                    mode="remote"
                                    @on-page-change="onPageChange"
                                    @on-sort-change="onSortChange"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    :totalRows="totalRecords"
                                    @on-select-all="onSelectAll"
                                    @on-cell-click="onRowClick"
                                    title="Citation"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :paginate="true"
                                    :paginationOptions="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                        enabled: canProcessCitation,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                        enabled: false,
                                    }"
                                >

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                    <div :key="key">
                                        <div>
                                            {{props.formattedRow[props.column.field]}}
                                        </div>
                                    </div>
                                </template>

                                <div slot="selected-row-actions">
                                    <button id="processCitation" v-if="canProcessCitation" v-on:click.prevent="storDate()" class="btn btn-primary">Process</button>
                                    <button id="deleteCitation" v-if="canProcessCitation" v-on:click.prevent="deleteInvoice()" class="btn btn-danger">Delete</button>
                                </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>

                        </section>
                        <div class="modal fade policy-modal" id="policy-modal" ref="policy-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="policy-modal" aria-hidden="true">
                                    <div class="modal-dialog" role="document">
                                        <div class="modal-content">
                                            <div class="modal-header">
                                                <h5 class="modal-title">Select File</h5>
                                            </div>
                                            <div class="modal-body">
                                                <form id="importFile" class="addinspectionForm">
                                                    <div class="form-row">
                                                        <div class="col form-group">
                                                            <label class="control-label require mb-2" for="name">File:</label><br/>
                                                            <input id="policyFile" type="file" @change="onFileChanged">
                                                            <div class="field-error">{{import_error}}</div>
                                                        </div>
                                                    </div>
                                                    <div class="form-row">
                                                        <div class="col form-group" v-if="fileName != ''">
                                                            <label class="control-label"> Download Sample file </label>
                                                            <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                        </div>
                                                    </div>
                                                </form>

                                                <div class="modal-footer">
                                                    <p v-if="importError" class="alert-danger p-2" id="importCitationHeadersCheckError">{{ importErrorMsg }}<button type="button" class="close close-alert" v-on:click="importError = false">×</button></p>
                                                    <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal" v-on:click="importError = false"> <i class="fp-close"> </i>Cancel</button>
                                                    <button class="btn btn-primary" id="importButton" v-on:click="importCitation()"> <i class="fp-import"> </i> Import</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                    </div>
                </div>
                <div class="modal fade select-date" :id="'select-date'" :ref="'select-date'" data-backdrop="static" data-keyboard="false" aria-labelledby="selectDate" aria-hidden="true">
                    <div class="modal-dialog modal-lg" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Invoice Process Date</h5>
                            </div>
                            <div class="modal-body">
                                <div class="form-row" >
                                    <div class="col-sm-6 form-group">
                                        <label class="control-label"  for="specialUnitDetail">Invoice Process Date:</label>
                                        <date-picker placeholder="MM/DD/YYYY" id="open_date" name="open_date" v-model="processdate" :config="optionsDate" aria-describedby="basic-addon3" class='cal-icon' :disabled="disableWOFields"></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button class="btn btn-primary" :id="'btnPOModalAdd'" v-on:click="processCitation()"> Yes </button>
                                <button type="button" class="btn btn-tertiary" id="cancelRecallAssetBtn" data-dismiss="modal"> No </button>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else-if="canAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

    import EventBus from "./event-bus";
    import Vue from 'vue';

    
    


    import moment from 'moment';
    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';
    import VueSSE from 'vue-sse'
    Vue.use(VueSSE);
    let msgServer;
    export default {
        name: "citationList",
        metaInfo: {
            title: "Citation List | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            hideButton:false,
            firstLoad:0,
            userColumns:[],
            columns: [
                {
                    label: 'Upload Date',
                    field: 'upload_date',
                    fpFieldType:"date",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
                {
                    label: 'Status',
                    field: 'upload_status',
                    fpFieldType:"option",
                    html: false,
                    filterable: true,
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Uploaded','In Progress','Processed'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Records',
                    field: 'records',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                },
                {
                    label: 'Errors',
                    field: 'error_count',
                    fpFieldType:"integer",
                    filterable: false,
                    hidden:false,
                },
                {
                    label: 'Created By',
                    field: 'created_by',
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false,
                },
                {
                    label: 'Created At',
                    field: 'created_at',
                    fpFieldType:"date",
                    html: false,
                    filterable: true,
                    hidden:false,

                },
            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            permissions:[],
            canAccessPage:'',
            action:'list',
            pageKey:"_citation_list_",
            selectedFile:"",
            batchId:'',
            batchProcess:false,
            batchNum:'',
            canProcessCitation:false,
            file:'',
            import_error:'',
            fileName:'',
            batchError:false,
            batchErrorMsg:"",
            processdate:'',
            disableWOFields:false,
            optionsDate: {
              format: 'MM/DD/YYYY',
              useCurrent: false,
              toolbarPlacement:'bottom',
              widgetPositioning: {
                  horizontal: 'auto',
                  vertical: 'bottom'
              },
            },
            importError:false,
            importErrorMsg: '',
            uploadedSelected: '',
            inProgressSelected: '',
            processedSelected: '',
            allSelected: '',
            flag: ''
        }),
        watch:{
            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'list_citation') {
                        self.canAccessPage = true;
                    }
                    if(permissions.name == 'process_citation') {
                        self.canProcessCitation = true;
                    } 
                });
                if (self.canAccessPage == ''){
                    self.canAccessPage = false;
                }
            }
        },
        created: function() {
            //this.serverParams.sort = {field:"start_date",type:"desc"};
        },
        mounted: function () {
            var self = this;
            // this.loadList();
            this.getPermissions();
            self.processdate = moment().format('MM/DD/YYYY');
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listCitationTable.unselectAllInternal();
            },
            checkBatchStatus:function(){
                var self =  this;
                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            self.loadList();
                            sse.close();
                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });

                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
            loadList: function(){

                var date = new Date();
                var offset = date.getTimezoneOffset();

                var data = this.$refs['listCitationTable'].selectedRows;
                var use = [];
                for (var i = 0; i < data.length; i++) {
                    use.push(this.$refs['listCitationTable'].selectedRows[i].id)
                }

                var self = this;
                self.loading =  true;
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/citation/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",

                    data:{
                        offset: offset,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: this.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        all: self.serverParams.selectedAll,
                        selectedRows: use,
                        action: self.action,
                        flag: self.flag
                    },
                    success: function (data) {
                        self.loading =  false;

                        if (data.status == "success") {
                            self.rows = data.content.row;
                            //
                            // self.perPage = data.content.perPage;
                            self.totalRecords = data.content.totalRecords;
                        }

                    },
                    error: function (jqXHR, exception) {
                        self.loading =  false;
                        self.generateStatusCodeMessage(jqXHR, false, 'citation-list')
                    }
                });
            },

            openModal: function(){
                var self = this;
                if (self.batchProcess){
                    self.$swal('','Previous batch already runnig','info');
                    return;
                }
                self.selectedFile = "";
                self.duplicatePolicy = [];
                $("#policyFile").val('');
                self.import_error = '';
                self.generateExcelSample();
                $('#policy-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                var self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            importCitation() {
                var self = this;

                self.import_error = "";
                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                var fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }
                console.log(self.selectedFile);

                var formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/citation/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.batch_id){
                            self.batchProcess = true;
                            self.batchId = data.batch_id;
                            self.batchNum = data.batch;
                            self.checkBatchStatus();
                            $('#policy-modal').modal('hide');
                        }
                        if(data.isMissingHeader){
                          self.importError = true;
                          self.importErrorMsg = data.message;
                        }
                            self.loadList();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                    }
                });
            },
            generateExcelSample:function(){
                var self = this;

                $.ajax({
                    url:
                    process.env.ROOT_API +
                    "/toll-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,

                    success: function(data) {
                        self.loading = false;
                        self.fileName = data.content.file;
                        self.file = data.content.web;

                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'telematics-reading-import')

                    }
                });
            },
            storDate(){
                $("#select-date").modal("show");
            },
            processCitation() {
                var self = this;
                if (self.batchProcess){
                    self.$swal('','Previous batch already runnig','info');
                    return;
                }
                var data = this.$refs['listCitationTable'].selectedRows;
                var use = [];
                var status = 'error';
                for (var i = 0; i < data.length; i++) {
                    if (data[i].upload_status == 'Uploaded'){
                        status = 'ok';
                        use.push(this.$refs['listCitationTable'].selectedRows[i].batch);

                    }
                }
                if (status == 'error'){
                    $("#select-date").modal("hide");
                    self.$swal('','Processed or In Progress Citation cannot be procesed','info');
                    return;
                }
                self.loading = true;

                $.ajax({
                    url: process.env.ROOT_API + "/citation-invoice/process",
                    type: "POST",
                    data: {
                        batch:use,
                        processdate:self.processdate
                    },
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        if (data.batch_id){
                            self.batchProcess = true;
                            self.batchId = data.batch_id;
                            self.batchNum = data.batch;
                            self.checkBatchStatus();
                        }
                        $("#select-date").modal("hide");
                            self.loadList();

                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $("#select-date").modal("hide");
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'policy-import-error')
                    }
                });
            },
            onRowClick(params,event) {

                var self = this;
                self.$router.push('/citation-detail/list/'+params.row.batch);

            },
            downloadSample(){
                var self = this;
                // alert(self.file);
                var docPath = self.file;
                var save = document.createElement('a');
                save.href = docPath;
                save.download = docPath;
                save.target = '_blank';
                document.body.appendChild(save);
                save.click();
                document.body.removeChild(save);
            },
            deleteInvoice() {
                var self = this;
                var data = self.$refs['listCitationTable'].selectedRows;
                console.log(data);
                self.$swal({
                    title: 'Are you sure that you want to delete this invoice?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                        var use = [];
                        var delete_status = 'error';
                        for (var i = 0; i < data.length; i++) {
                            if(self.$refs['listCitationTable'].selectedRows[i].upload_status == "Uploaded"){
                                use.push(self.$refs['listCitationTable'].selectedRows[i].batch);
                                delete_status = 'ok';
                            }
                        }
                        if (delete_status == 'error'){
                            self.$swal('','Processed or In Progress Citation cannot be deleted','info');
                            return;
                        }

                        // self.loadList();
                        $.ajax({
                            url: process.env.ROOT_API + "/citation/delete",
                            type: "POST",
                            data: {
                            list: use,
                            },
                            headers: this.ajxHeaders,
                            dataType: "json",
                            success: function (data) {
                                self.loading = false;
                                if (data.status == "success") {
                                self.$swal('','Citation Deleted successfully','success');
                                self.cancelAll(true);
                                self.loadList();
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.loading = false;
                                self.generateStatusCodeMessage(jqXHR,false,'citation-invoice-status-change');
                            }
                    });
                    } else {
                    }
                });
            },
            getUploadedCitationList: function() {
                var self = this;
              $('#divTabMenu button').removeClass("active");
              $("#getUploadedCitationList").addClass("active");
              self.$refs.filterComponent.clearSelectAll();
              localStorage.setItem('citation_list_prev_tab', 'uploaded');
              self.uploadedSelected = "active";
              self.inProgressSelected = "";
              self.processedSelected = "";
              self.allSelected = '';
              self.flag = 'uploaded';
              self.loadList();
            },
            getInProgressCitationList: function() {
                var self = this;
              $('#divTabMenu button').removeClass("active");
              $("#getInProgressCitationList").addClass("active");
              self.$refs.filterComponent.clearSelectAll();
              localStorage.setItem('citation_list_prev_tab', 'in_progress');
              self.uploadedSelected = "";
              self.inProgressSelected = "active";
              self.processedSelected = "";
              self.allSelected = '';
              self.flag = 'in_progress';
              self.loadList();
            },
            getProcessedCitationList: function() {
                var self = this;
              $('#divTabMenu button').removeClass("active");
              $("#getProcessedCitationList").addClass("active");
              self.$refs.filterComponent.clearSelectAll();
              localStorage.setItem('citation_list_prev_tab', 'processed');
              self.uploadedSelected = "";
              self.inProgressSelected = "";
              self.processedSelected = "active";
              self.allSelected = '';
              self.flag = 'processed';
              self.loadList();
            },
            getAllCitationList: function() {
                var self = this;
              $('#divTabMenu button').removeClass("active");
              $("#getAllCitationList").addClass("active");
              self.$refs.filterComponent.clearSelectAll();
              localStorage.setItem('citation_list_prev_tab', 'all');
              self.uploadedSelected = "";
              self.inProgressSelected = "";
              self.processedSelected = "";
              self.allSelected = 'active';
              self.flag = 'all';
              self.loadList();
            },
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/CitationList.vue